import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1505.84533,72.0933333 L1318.32533,295.56 C1274.16533,262.92 1224.992,234.546667 1171.12533,211.613333 C1103.28533,183.986667 1032.352,167.773333 960.032,162.226667 L960.032,53 L853.365333,53 L853.365333,162.333333 C495.925333,189.746667 213.365333,488.733333 213.365333,853 L213.365333,1226.33333 C213.365333,1282.76 190.645333,1337.90667 151.072,1377.37333 C111.605333,1416.94667 56.4586667,1439.66667 0.032,1439.66667 L0.032,1546.33333 L269.365333,1546.33333 L119.178667,1725.42667 L200.885333,1793.90667 L1587.552,140.573333 L1505.84533,72.0933333 Z M1479.46667,462.6 C1558.29333,577.586667 1600,712.626667 1600,853 L1600,853 L1600,1226.33333 C1600,1343.98667 1695.68,1439.66667 1813.33333,1439.66667 C1842.77333,1439.66667 1866.66667,1463.56 1866.66667,1493 C1866.66667,1522.44 1842.77333,1546.33333 1813.33333,1546.33333 L1813.33333,1546.33333 L1226.66667,1546.33333 C1226.66667,1722.76 1083.09333,1866.33333 906.666667,1866.33333 C730.24,1866.33333 586.666667,1722.76 586.666667,1546.33333 L586.666667,1546.33333 L586.666667,1493 C586.666667,1463.56 610.56,1439.66667 640,1439.66667 L640,1439.66667 L1575.04,1439.66667 C1524.26667,1383.02667 1493.33333,1308.25333 1493.33333,1226.33333 L1493.33333,1226.33333 L1493.33333,853 C1493.33333,734.28 1458.13333,620.04 1391.57333,522.973333 L1391.57333,522.973333 Z M1120,1546.33333 L693.333333,1546.33333 C693.333333,1663.98667 789.013333,1759.66667 906.666667,1759.66667 C1024.32,1759.66667 1120,1663.98667 1120,1546.33333 L1120,1546.33333 Z M906.698667,266.333333 C983.818667,266.333333 1059.12533,281.16 1129.952,310.066667 C1173.68533,328.733333 1213.792,351.88 1249.52533,377.693333 L358.858667,1439.66667 L238.858667,1439.66667 C290.592,1381.64 320.032,1304.84 320.032,1226.33333 L320.032,853 C320.032,529.586667 583.285333,266.333333 906.698667,266.333333 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMutedLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMutedLine, _Component);

  var _super = _createSuper(IconMutedLine);

  function IconMutedLine() {
    _classCallCheck(this, IconMutedLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMutedLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMuted",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMutedLine.displayName = "IconMutedLine";
  return IconMutedLine;
}(Component);

IconMutedLine.glyphName = 'muted';
IconMutedLine.variant = 'Line';
IconMutedLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMutedLine;
export { IconMutedLine };